import { render, staticRenderFns } from "./CheckoutManagerPage.vue?vue&type=template&id=8dbf5460"
import script from "./CheckoutManagerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutManagerPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports